"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./SelectionPanel.css");
var SelectionPanelProps_1 = require("./SelectionPanelProps");
var utils_1 = require("../../../utils/utils");
var getDisplayName = function (Comp) { return Comp.displayName || Comp.name || 'Component'; };
// TODO: extract SelectionPanel to 2 wrapping functions to prevent the user from passing the type property
// export const buildSingleSelectionPanel = (WrappedComponentWithCards: React.ComponentClass) =>
//   SelectionPanel(WrappedComponentWithCards, SelectionPanelType.SINGLE);
// export const buildMultiSelectionPanel = (WrappedComponentWithCards: React.ComponentClass) =>
//   SelectionPanel(WrappedComponentWithCards, SelectionPanelType.MULTI);
var SelectionPanel = function (WrappedComponentWithCards) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    selected: _this.props.data && _this.props.data.value ? _this.props.data.value : [],
                };
                _this.onSelect = _this.onSelect.bind(_this);
                _this.onSelectPanel = _this.onSelectPanel.bind(_this);
                return _this;
            }
            class_1.prototype.onSelect = function (selectionCard) {
                if (this.props.options.type === SelectionPanelProps_1.SelectionPanelType.SINGLE) {
                    this.setState({ selected: [selectionCard] }, this.onSelectPanel);
                }
                else {
                    // Multi
                    var list = this.state.selected.slice();
                    if (list.includes(selectionCard)) {
                        // remove
                        var removeIndex = list.findIndex(function (item) { return item.id === selectionCard.id; });
                        this.setState({ selected: __spread(list.slice(0, removeIndex), list.slice(removeIndex + 1)) }, this.onSelectPanel);
                    }
                    else {
                        // add
                        this.setState({ selected: __spread(list, [selectionCard]) }, this.onSelectPanel);
                    }
                }
            };
            class_1.prototype.onSelectPanel = function () {
                var type = this.props.options.type;
                var selected = type === SelectionPanelProps_1.SelectionPanelType.SINGLE ? this.state.selected[0] : this.state.selected;
                this.props.events.onSelect(selected);
            };
            class_1.prototype.render = function () {
                var type = this.props.options.type;
                var injectedProps = {
                    events: { onSelect: this.onSelect },
                    options: __assign(__assign({}, this.props.options), { type: type }),
                };
                return (React.createElement(WrappedComponentWithCards, __assign({ testId: utils_1.default(this.props.testId, 'Card') }, injectedProps)));
            };
            return class_1;
        }(React.Component)),
        _a.displayName = "SelectionPanel(" + getDisplayName(WrappedComponentWithCards) + ")",
        _a;
};
exports.default = SelectionPanel;
//# sourceMappingURL=SelectionPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/SelectionPanel/SelectionPanel.js
// module id = 1409
// module chunks = 8